import React from "react"
import styled from "styled-components"
import { rem } from "polished"
import { media } from "@sr/common"
import {
  SemiBdTitle4,
  RegBody,
  IconArrowRight,
  IconClock,
  IconWifi,
  IconParking,
  IconSmartHome,
  IconDoorOpen,
  IconPhone,
  IconCheckSolid,
  IconSearch,
  IconClipboardTask,
  IconMobilePhone,
} from "@sr/gatsby-theme-ui"
import { Link } from "gatsby"
export interface CaseStudyEntrySidebarPropsShape {
  sidebar: {
    company: string
    headquarters: string
    industry: string
    productsUsed: string[]
  }
}

const sidebarProductsUsedMap = [
  {
    label: "Access Control",
    icon: <IconClock className="sidebar__products-icon" />,
    link: "/products/access-control/",
  },
  {
    label: "Community WiFi",
    icon: <IconWifi className="sidebar__products-icon" />,
    link: "/products/community-wifi/",
  },
  {
    label: "Parking Management",
    icon: <IconParking className="sidebar__products-icon" />,
    link: "/products/smart-parking-management/",
  },
  {
    label: "Smart Apartments",
    icon: <IconSmartHome className="sidebar__products-icon" />,
    link: "/products/smart-apartments-homes/",
  },
  {
    label: "Self-Guided Tours (SGT)",
    icon: <IconDoorOpen className="sidebar__products-icon" />,
    link: "/products/self-guided-tours/",
  },
  {
    label: "Answer Automation",
    icon: <IconPhone className="sidebar__products-icon" />,
    link: "/products/answer-automation/",
  },
  {
    label: "Work Management",
    icon: <IconCheckSolid className="sidebar__products-icon" />,
    link: "/products/work-management/",
  },
  {
    label: "Inspection Management",
    icon: <IconSearch className="sidebar__products-icon" />,
    link: "/products/inspection-management/",
  },
  {
    label: "Audit Management",
    icon: <IconClipboardTask className="sidebar__products-icon" />,
    link: "/products/audit-management/",
  },
  {
    label: "Resident App & Experience",
    icon: <IconMobilePhone className="sidebar__products-icon" />,
    link: "/products/resident-app-and-experience/",
  },
]

const CaseStudyEntrySidebar = ({
  sidebar,
}: CaseStudyEntrySidebarPropsShape) => {
  return (
    <CaseStudyEntrySidebarStyled>
      <div className="sidebar__data-container">
        <div>
          <SemiBdTitle4 className="sidebar__title">Company</SemiBdTitle4>
          <RegBody>{sidebar.company}</RegBody>
        </div>
        <div>
          <SemiBdTitle4 className="sidebar__title">Industry</SemiBdTitle4>
          <RegBody>{sidebar.industry}</RegBody>
        </div>
        <div>
          <SemiBdTitle4 className="sidebar__title">Headquarters</SemiBdTitle4>
          <RegBody>{sidebar.headquarters}</RegBody>
        </div>
        <div>
          <SemiBdTitle4 className="sidebar__title">Products Used</SemiBdTitle4>

          <div className="sidebar__products-container">
            {sidebar.productsUsed.map((el: string, i: number) => {
              let currProduct = sidebarProductsUsedMap.find(
                (product) => product.label === el
              )
              if (currProduct?.link && currProduct?.label && currProduct?.icon)
                return (
                  <div className="sidebar__products" key={i}>
                    {currProduct?.icon}
                    <Link to={currProduct?.link}>
                      <RegBody className="sidebar__products-text">
                        {currProduct?.label}
                      </RegBody>
                    </Link>
                  </div>
                )
            })}
          </div>
        </div>
      </div>
      <SemiBdTitle4 className="sidebar__title">
        Ready to get started?
      </SemiBdTitle4>
      <Link
        to="/contact-smartrent/"
        rel="noopener noreferrer"
        className="sidebar__learn-more-link"
      >
        <div>
        Let's Talk
          <IconArrowRight />
        </div>
      </Link>
    </CaseStudyEntrySidebarStyled>
  )
}

export default CaseStudyEntrySidebar

const CaseStudyEntrySidebarStyled = styled.section`
  width: calc(100% - 32px);
  max-width: ${rem(520)};
  height: auto;
  position: relative;
  display: flex;
  flex-direction: column;
  margin: ${rem(16)};
  padding: ${rem(24)} ${rem(40)} ${rem(48)};
  border-radius: 8px;
  box-shadow: 0px 4px 50px rgba(0, 0, 0, 0.1);
  min-height: ${rem(80)};

  @media ${media.stMidUp} {
    position: sticky;
    top: ${rem(70)};
    max-width: ${rem(344)};
    margin: 72px 0 0 0;
    padding: ${rem(36)} ${rem(40)};
  }

  .sidebar__data-container {
    display: flex;
    flex-direction: column;
    gap: ${rem(24)};
    padding-top: ${rem(12)};
  }

  .sidebar__title {
    @media ${media.stMidUp} {
      font-size: ${rem(20)};
    }
  }

  .sidebar__products-container {
    padding: ${rem(24)} 0 ${rem(48)};
    display: flex;
    flex-direction: column;
    gap: ${rem(24)};
  }

  .sidebar__products {
    display: flex;
    padding: ${rem(2)};
  }

  .sidebar__products-text {
    margin-left: ${rem(8)};
    color: var(--color-gray900);
    cursor: pointer;
  }

  .sidebar__learn-more-link {
    cursor: pointer;
    font-weight: 600;

    div {
      display: flex;
      align-items: center;
    }

    svg {
      height: ${rem(20)};
      width: ${rem(20)};
      margin-left: ${rem(10)};
      fill: var(--color-primary);
    }
  }
`
